import { render, staticRenderFns } from "./HorizontalBanners.vue?vue&type=template&id=276fb362&scoped=true"
import script from "./HorizontalBanners.vue?vue&type=script&lang=js"
export * from "./HorizontalBanners.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBanners.vue?vue&type=style&index=0&id=276fb362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fb362",
  null
  
)

export default component.exports